module.exports = " <div *ngIf=\"loading\" style=\"position: relative\">\r\n     <img src=\"./assets/images/loading.gif\" width=\"30px\" height=\"30px\" style=\"position:absolute; margin-top:-20px\"/>\r\n </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/loader-data/loader.component.html
// module id = ./src/app/shared/component/loader-data/loader.component.html
// module chunks = main